export default "__VITE_ASSET__BWQfQFq0__"